import { Suspense, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import colors from '@rewardopl/styles/colors';

import Dialog from '@rewardopl/react-ui/dialog';

import { CodeWrapper, Text } from './index.styles';

import DynamicCode from '../../../common/dynamic_code';
import EmailVerificationRoadblock from '../../../common/email_verification_roadblock';
import RewardsAndCoupons from './rewards_and_coupons';

import { currentUserState } from '../../../../store';

export default function YourCodeDialog() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = useAtomValue(currentUserState);

  const { is_email_verified: isEmailVerified = true } = currentUser;

  const closeDialog = useCallback(() => {
    navigate(
      {
        ...location,
        hash: '',
      },
      { state: location.state },
    );
  }, [location, navigate]);

  return (
    <Dialog isOpen={location.hash === '#your-code'} onDismiss={closeDialog} title="My card">
      {isEmailVerified ? (
        <>
          <Text>
            <T>Show this code to the cashier.</T>
          </Text>
          <CodeWrapper>
            <Suspense fallback={null}>
              <DynamicCode color={colors.text} />
            </Suspense>
          </CodeWrapper>
          <RewardsAndCoupons />
        </>
      ) : (
        <EmailVerificationRoadblock showIcon />
      )}
    </Dialog>
  );
}
